import { widgetsConfigurations } from 'config/widgetConfigurations/widgetsConfigurations';

import { IComponentKey } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * 🎯 Purpose:
 * Defines the list of widget component keys that have been fully migrated
 * and are officially supported by the reporting system.
 *
 * Only widgets included in this list are allowed to render in the add component modal.
 */

export const WHITELISTED_REPORTING_COMPONENT_KEYS: IComponentKey[] = [
    widgetsConfigurations.reportSummary.componentKey,
    widgetsConfigurations.resourcesAnalysisChart.componentKey,
    widgetsConfigurations.activityPredecessors.componentKey,
    widgetsConfigurations.riskHeatMap.componentKey,
    widgetsConfigurations.topOverdueOverrunActivities.componentKey,
    widgetsConfigurations.criticalityWeightedSCurve.componentKey,
    widgetsConfigurations.highLevelProgramLatest.componentKey,
    widgetsConfigurations.sharedResourcesAvailability.componentKey,
    widgetsConfigurations.progressSummary.componentKey,
    widgetsConfigurations.topCriticalActivitiesDelayDrivers.componentKey,
    widgetsConfigurations.customReportText.componentKey,
    widgetsConfigurations.keyActivities.componentKey,
    widgetsConfigurations.finishDateOverallSummary.componentKey,
    widgetsConfigurations.finishDateActivitiesPredecessors.componentKey,
    widgetsConfigurations.productivityRate.componentKey,
    widgetsConfigurations.projectScorecards.componentKey,
    widgetsConfigurations.projectSummary.componentKey,
    widgetsConfigurations.timelineAndDensity.componentKey,
    widgetsConfigurations.trends.componentKey,
    widgetsConfigurations.scheduleQualityScore.componentKey,
    widgetsConfigurations.currentSpi.componentKey,
    widgetsConfigurations.scheduleDelay.componentKey,
    widgetsConfigurations.productivityRiskKpi.componentKey,
    widgetsConfigurations.topFinishDateChanges.componentKey,
    widgetsConfigurations.topStartDateChanges.componentKey,
    widgetsConfigurations.topStatusChanges.componentKey,
    widgetsConfigurations.largestAddedActivities.componentKey,
    widgetsConfigurations.largestDeletedActivities.componentKey,
    widgetsConfigurations.criticalPathAdded.componentKey,
    widgetsConfigurations.criticalPathRemoved.componentKey,
    widgetsConfigurations.largestFloatChanges.componentKey,
    widgetsConfigurations.largestDurationVariance.componentKey,
    widgetsConfigurations.topRelationshipsTypeChanges.componentKey,
    widgetsConfigurations.topRelationshipsCountChanges.componentKey,
    widgetsConfigurations.outOfSequence.componentKey,
    widgetsConfigurations.danglingLogic.componentKey,
    widgetsConfigurations.leads.componentKey,
    widgetsConfigurations.lags.componentKey,
    widgetsConfigurations.relationshipTypes.componentKey,
    widgetsConfigurations.hardConstraints.componentKey,
    widgetsConfigurations.highFloatByActivityType.componentKey,
    widgetsConfigurations.negativeFloatByActivityType.componentKey,
    widgetsConfigurations.longDuration.componentKey,
    widgetsConfigurations.invalidActualDates.componentKey,
    widgetsConfigurations.invalidForecastDates.componentKey,
    widgetsConfigurations.unresourcedActivities.componentKey,
    widgetsConfigurations.missedActivities.componentKey,
    widgetsConfigurations.criticalPathTest.componentKey,
    widgetsConfigurations.criticalPathLengthIndex.componentKey,
    widgetsConfigurations.baselineExecutionIndex.componentKey,
    widgetsConfigurations.missingBaselineDates.componentKey,
    widgetsConfigurations.duplicateRelations.componentKey,
    widgetsConfigurations.softConstraints.componentKey,
    widgetsConfigurations.allScheduleQualityChecks.componentKey,
    widgetsConfigurations.prioritiesMatrix.componentKey,
    widgetsConfigurations.keyAchievements.componentKey,
    widgetsConfigurations.changeSummary.componentKey,
    widgetsConfigurations.spiTrend.componentKey,
    widgetsConfigurations.productivityRiskTrend.componentKey,
    widgetsConfigurations.scheduleQualityTrend.componentKey,
];
